/** The signed-in member's Quantis Field access in a workspace, named once so
 *  Profile and the background warm share one cache entry per actor and
 *  workspace. The server answers every member, so it costs no 403. */

import { SoftwareBillingService } from '../../services/SoftwareBillingService';

export type FieldAccess = Awaited<ReturnType<typeof SoftwareBillingService.access>>;

export const fieldAccessRead = (workspaceId: string) => ({
  name: 'profile/field-access',
  load: (signal?: AbortSignal): Promise<FieldAccess> => SoftwareBillingService.access(workspaceId, signal),
});
